// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "e3634027ce6243ad4962fe566f812fbf" + ".js";
};